<template>
  <BaseError v-if="error" />
  <div v-else :class="['c-layout', { 'c-layout--alert': alertVisible }]">
    <template v-if="isLoaded">
      <div class="c-layout--header">
        <Header :genre-name="genreName" :genre-slug="genreSlug" />
        <Breadcrumbs />
        <Alert />
        <NavigationHeader />
      </div>

      <div :class="['c-layout--main', className]">
        <slot></slot>
      </div>
    </template>

    <template v-if="!token">
      <slot></slot>
    </template>
    <CookieFooter v-if="!isCustomElement && isLoaded" />
    <ModalContainer />
  </div>
</template>

<script lang="ts" setup>
import Breadcrumbs from '@/components/breadcrumbs/BaseBreadcrumbs.vue';
import Header from '@/components/header/BaseHeader.vue';
import { ref, watch, computed } from 'vue';
import Loader from '@/components/loader/BaseLoader.vue';
import { useAuth } from '@/core';
import NavigationHeader from '@/components/navigation-header/NavigationHeader.vue';
import CookieFooter from '@/components/cookie-footer/CookieFooter.vue';
import useGenre from '@/services/useGenre';
import ModalContainer from '@/components/layout/modal/ModalContainer.vue';
import useModal from '@/services/useModal';
import Alert from '@/components/alert/BaseAlert.vue';
import useAlert from '@/services/useAlert';
import useError from '@/services/useError';
import BaseError from '@/views/BaseError.vue';

interface LayoutProps {
  className?: string;
  isCustomElement?: boolean;
}

defineProps<LayoutProps>();

const modal = useModal();
const { token } = useAuth();
const isLoaded = ref<boolean>(false);
const { alerts } = useAlert();
const { error } = useError();

const { genre } = useGenre();
const genreSlug = ref<string>('/');
const genreName = ref<string>('');

watch(genre, () => {
  genreSlug.value = genre.value.slug;
  genreName.value = genre.value.name;
});

const setLoaded = () => {
  isLoaded.value = true;
};

if (!isLoaded.value) {
  modal.open(
    Loader,
    {},
    {
      loaded: setLoaded,
    },
  );
}

const alertVisible = computed(() => alerts.value.length);
</script>
